import { FieldArrayWithId } from "react-hook-form";
import { SalaryFormValues } from "../../../hooks/useTesSalaryComponents";

export enum EmploymentRowType {
  Upcoming = "upcoming",
  Open = "open",
  Past = "past",
  Cancelled = "cancelled",
}

export type SelectedSalaryRow = FieldArrayWithId<
  { salaryRows: SalaryFormValues[] },
  "salaryRows",
  "id"
> & { isCopy: boolean };
